import { type HTMLAttributes, type ReactNode, type Ref } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { type DistributiveOmit } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import styles from './ChartLegend.module.scss'

type Props = {
  children: ReactNode
}

export const ChartLegend = ({ children }: Props) => <ul className={styles.container}>{children}</ul>

type ItemProps = {
  color?: string
  isActive?: boolean
  isDimmed?: boolean
  label: string
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  value?: string
}

type ChartLegendItemProps = ItemProps &
  DistributiveOmit<HTMLAttributes<HTMLElement>, keyof ItemProps | 'children'> & { ref?: Ref<HTMLButtonElement> }

export const ChartLegendItem = ({
  color,
  isActive,
  isDimmed,
  label,
  onClick,
  onMouseEnter,
  onMouseLeave,
  ref,
  value,
  ...props
}: ChartLegendItemProps) => {
  const className = cn(styles.item, { isActive, isDimmed, styles })

  const content = (
    <>
      <span className={styles.swatch} style={{ backgroundColor: color || '#fff' }} />
      <span className={styles.label}>{label}</span>
      {value !== undefined && (
        <span className={styles.value}>
          (<span>{value}</span>)
        </span>
      )}
    </>
  )

  if (!onClick && !onMouseEnter && !onMouseLeave)
    return (
      <li>
        <ButtonRoot {...props} as='div' className={className}>
          {content}
        </ButtonRoot>
      </li>
    )

  return (
    <li>
      <ButtonRoot
        {...props}
        className={className}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        ref={ref}
      >
        {content}
      </ButtonRoot>
    </li>
  )
}
